import * as Yup from 'yup';

export const AvailabilityCountSchema = Yup.object().shape({
  count: Yup.number(),
});

export type AvailabilityCountDataType = Yup.InferType<
  typeof AvailabilityCountSchema
>;

type InitialValues = {
  count: number;
};

export const availabilityCountValue: InitialValues = {
  count: 0,
};
